import * as S from './styles';

interface Props {
  children: React.ReactNode;
}

export const EmptyMessageBox = ({ children }: Props) => {
  return (
    <S.Container>
      <S.MessageBox>{children}</S.MessageBox>
    </S.Container>
  );
};
